import React from 'react';
import { Modal, Timeline, Typography } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const { Title, Text } = Typography;

const HistoryBadge = styled.div`
	background-color: #eaffea;
	color: #4cd964;
	padding: 4px 10px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 600;
	display: inline-block;
	word-break: break-word;
	margin-bottom: 8px;
`;

const TimelineDescription = styled(Text)`
	font-size: 13px;
	color: #595959;
	display: block;
	margin-bottom: 4px;
`;

const TimelineTimestamp = styled(Text)`
	font-size: 12px;
	color: #8c8c8c;
	display: block;
`;

function TripHistoryModal({ visible, onCancel, historyData }) {
	return (
		<Modal
			visible={visible}
			onCancel={onCancel}
			title={
				<Title level={5} style={{ margin: 0, color: '#1f3e5a' }}>
					Status History
				</Title>
			}
			footer={null}
			width={400}
			centered
		>
			<div style={{ padding: '16px 0', marginLeft: '16px' }}>
				<Timeline>
					{historyData?.map((item, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<Timeline.Item key={index} color={item.status_color || '#1890ff'}>
							<HistoryBadge>{item.event_display}</HistoryBadge>

							<TimelineDescription>{item.display_text}</TimelineDescription>

							<TimelineTimestamp>{item.timestamp_display}</TimelineTimestamp>
						</Timeline.Item>
					))}
				</Timeline>
			</div>
		</Modal>
	);
}

TripHistoryModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	historyData: PropTypes.array,
};

export default TripHistoryModal;
